/**
 * 封装http请求
 */
import ajax from "@/lib/ajax";
import { isString } from "../common/util.js";

export function httpPost(url, params = {}) {
    let options = isString(params) || params instanceof FormData ? { stringify: str => str } : undefined;
    return ajax.post(url, params, options).then(resp => {
        if (resp instanceof Error) {
            throw resp;
        }
        return resp;
    });
}

export function httpGet(url, params = {}) {
    return ajax.get(url, params).then(resp => {
        if (resp instanceof Error) {
            throw resp;
        }
        return resp;
    });
}
